import React, {Component} from "react"
import styled from "styled-components"
import {Row, Col} from "react-bootstrap"
import Sticky from "react-sticky-el"
import {Dispatch} from "redux"

import Form from "@irati/ui/src/Form"
import {Hr} from "@irati/ui/src/Layout"
import authentication from "@irati/auth"
import connect from "@irati/store/connect"
import {H2, H4} from "@irati/ui/src//Typography/Heading"
import {injectIntl, InjectIntl} from "@irati/utils/lang"
import Recipients from "@irati-web/reward/src/components/Recipients"
import Card from "@irati/ui/src/Layout/Card"
import {ReduxState} from "@irati/store/types"
import {Para} from "@irati/ui/src/Labels"
import WalletActions, {GetWallet} from "@irati/wallet/store/actions/Wallet"
import history from "@irati/utils/history"
import {sendCreditToUser} from "@irati/wallet/graph/wallet"
import Flex from "@irati/ui/src/Flex"
import {getCentValue} from "@irati/utils/currency/formatCurrency"

import Sidebar from "../../components/Sidebar"
import Wallet from "../../images/wallet_badge.svg"

const StyledForm = styled(Form)`
  margin-top: 30px;
`

const Image = styled.img`
  width: 50px;
  height: 50px;
  margin-right: 15px;
  ${({theme}) => theme.mediaQueries.minWidthMedia.tablet`
    width: 80px;
    height: 80px;
    margin-right: 20px;
  `}
`

interface Props extends InjectIntl {
  isMobile: boolean,
  getWallet: () => void,
  wallet: Wallet
}

interface State {
  amount: number,
  recipients: [],
  load: Promise<any> | null,
  error: string | null
}

class SendCreditContainer extends Component<Props, State> {
  state: State = {
    amount: 0,
    recipients: [],
    load: null,
    error: null
  }

  componentDidMount = () => {
    this.props.getWallet()
  }

  submit = () => {
    const {wallet, getWallet} = this.props
    const {recipients, amount: amountInCents} = this.state
    const senderId = authentication.user().uuid

    const currency = wallet.currency
    const amount = getCentValue(currency, amountInCents)

    if (recipients.length > 0 && amount && wallet.currency) {
      this.setState({
        load: sendCreditToUser(senderId, recipients[0].uuid, amount, currency)
          .then(() =>
            getWallet({}).then(() => {
              history.push({pathname: "/wallet", state: {recipient: recipients[0], amount}})
            })
          )
          .catch((err) => this.setState({error: err.message}))
      })
    }
  }

  setRecipients = (recipients: User[]) => {
    this.setState({recipients})
  }

  handleChangeAmount = (value: number) => this.setState({amount: value})

  render() {
    const {isMobile, formatMessage, wallet} = this.props
    const {amount, recipients, load, error} = this.state
    return (
      <StyledForm>
        <Col md={8} sm={12}>
          <Card large>
            <Row>
              <Flex alignItems="center">
                <Image src={Wallet} alt="send-credit-image" />
                <H2>{formatMessage({id: "wallet.sendCredit.title"})}</H2>
              </Flex>
              <Hr large />
              <Para>{formatMessage({id: "wallet.sendCredit.desc.text"})}</Para>
              <H4 small>{formatMessage({id: "wallet.sendCredit.desc.title"})}</H4>
            </Row>
            <Recipients allowMultipleRecipients={false} recipients={recipients} setRecipients={this.setRecipients} />
          </Card>
        </Col>
        <Col md={4} sm={12}>
          {isMobile ? (
            <Sidebar
              wallet={wallet}
              amount={amount}
              recipients={recipients}
              load={load}
              error={error}
              onChange={this.handleChangeAmount}
              onSubmit={this.submit} />
          ) : (
            <Sticky stickyStyle={{marginTop: "20px"}}>
              <Sidebar
                wallet={wallet}
                amount={amount}
                recipients={recipients}
                load={load}
                error={error}
                onChange={this.handleChangeAmount}
                onSubmit={this.submit} />
            </Sticky>
          )}
        </Col>
      </StyledForm>
    )
  }
}

const mapStateToProps = ({mq, wallet}: ReduxState) => ({
  isMobile: mq.lessThan.md,
  wallet
})

const mapDispatchToProps = (dispatch: Dispatch<any>): {getWallet: GetWallet} => {
  return {
    getWallet: () => dispatch(WalletActions.get())
  }
}

export default injectIntl(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(SendCreditContainer)
)
